import { createFileRoute } from "@tanstack/react-router";
import { useServerFn } from "@tanstack/react-start";
import { useQuery } from "@tanstack/react-query";
import { getHealthSummary } from "@/lib/monitoring.functions";
import { listJobs } from "@/lib/job-queue.functions";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

export const Route = createFileRoute("/_authenticated/app/monitoring")({
  component: MonitoringPage,
});

function MonitoringPage() {
  const fetchHealth = useServerFn(getHealthSummary);
  const fetchJobs = useServerFn(listJobs);
  const health = useQuery({ queryKey: ["health-summary"], queryFn: () => fetchHealth(), refetchInterval: 15000 });
  const jobs = useQuery({ queryKey: ["job-queue"], queryFn: () => fetchJobs(), refetchInterval: 10000 });

  return (
    <div className="container mx-auto p-6 space-y-6">
      <h1 className="text-3xl font-bold">System-Monitoring</h1>

      <div className="grid md:grid-cols-3 gap-4">
        <Card>
          <CardHeader><CardTitle>Job-Queue</CardTitle></CardHeader>
          <CardContent className="space-y-1 text-sm">
            {Object.entries(health.data?.queueCounts ?? {}).map(([k, v]) => (
              <div key={k} className="flex justify-between"><span>{k}</span><Badge variant="secondary">{v}</Badge></div>
            ))}
            {!health.data?.queueCounts && <p className="text-muted-foreground">Keine Jobs.</p>}
          </CardContent>
        </Card>

        <Card>
          <CardHeader><CardTitle>Fehler (letzte 200)</CardTitle></CardHeader>
          <CardContent className="space-y-1 text-sm">
            {Object.entries(health.data?.errCounts ?? {}).map(([k, v]) => (
              <div key={k} className="flex justify-between"><span>{k}</span><Badge variant={k === "critical" ? "destructive" : "secondary"}>{v}</Badge></div>
            ))}
          </CardContent>
        </Card>

        <Card>
          <CardHeader><CardTitle>Workflows / Kosten</CardTitle></CardHeader>
          <CardContent className="text-sm space-y-1">
            <div>Workflows: <strong>{health.data?.workflows.count ?? 0}</strong></div>
            <div>Kosten gesamt: <strong>{(health.data?.workflows.totalCost ?? 0).toFixed(4)} €</strong></div>
            <div>Tokens gesamt: <strong>{health.data?.workflows.totalTokens ?? 0}</strong></div>
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader><CardTitle>Letzte Jobs</CardTitle></CardHeader>
        <CardContent>
          <div className="space-y-2 text-sm">
            {(jobs.data ?? []).slice(0, 20).map((j: { id: string; kind: string; status: string; retry_count: number; created_at: string }) => (
              <div key={j.id} className="flex justify-between border-b py-1">
                <span>{j.kind}</span>
                <span className="text-muted-foreground">{new Date(j.created_at).toLocaleString()}</span>
                <Badge variant={j.status === "failed" ? "destructive" : j.status === "succeeded" ? "default" : "secondary"}>
                  {j.status} ({j.retry_count})
                </Badge>
              </div>
            ))}
            {!jobs.data?.length && <p className="text-muted-foreground">Keine Jobs.</p>}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
